import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * `PublicNotFound` — the same component rendered for every failure mode
 * on the public surface (`/events/:id`):
 *   - the event id does not exist,
 *   - the event exists but is `internal`,
 *   - the event exists but is `cancelled`,
 *   - the event exists but is archived (`is_active=false`).
 *
 * Per `spec/pages/public/event-detail.md` §4 + the threat model in
 * `01-08-public-surface-PLAN.md` (T-08-S3), the rendered DOM must not
 * differentiate between these conditions — the goal is to prevent a
 * probe attacker from enumerating internal event IDs by comparing
 * response shapes.
 *
 * Copy is verbatim from `01-UI-SPEC.md` §"Copywriting Contract" entry
 * "Error — public event not found".
 */
export const PublicNotFound = () => (
    <Box textAlign="center" py={6}>
        <Typography variant="h1" component="h1">
            Event not found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
            This event may have been moved or is no longer public. Browse
            upcoming events on the calendar.
        </Typography>
        <Button
            component={Link}
            to="/calendar"
            variant="contained"
            sx={{ mt: 3 }}
        >
            Back to calendar
        </Button>
    </Box>
);

export default PublicNotFound;
